import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f2e73fba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f2e73fba&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e73fba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2e73fba')) {
      api.createRecord('f2e73fba', component.options)
    } else {
      api.reload('f2e73fba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f2e73fba&scoped=true&", function () {
      api.rerender('f2e73fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/arbitrator/deploy/index.vue"
export default component.exports